import { useEffect } from "react";
import ReactPlayer from "react-player";
import { Flex, Button, Form, Input } from "antd";

import StyledModal from "./style";

const ModalSettingsVideo = ({
  activeVideoUrl,
  loading,
  onCancel,
  onSuccess,
  open,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && activeVideoUrl)
      form.setFieldsValue({ videoUrl: activeVideoUrl });
  }, [open]);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            form="formDashboardVideo"
            htmlType="submit"
            shape="round"
          >
            Update
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title="Dashboard Video"
      width={647}
    >
      <Form
        form={form}
        id="formDashboardVideo"
        layout="vertical"
        onFinish={onSuccess}
      >
        <Form.Item
          label="Paste a hosting URL (youtube, etc)"
          name="videoUrl"
          rules={[
            {
              required: true,
              type: "url",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>

      {activeVideoUrl && (
        <>
          <p style={{ marginBottom: 8 }}>Current Video</p>
          <ReactPlayer
            controls={true}
            height={195}
            url={activeVideoUrl}
            width="291px"
          />
        </>
      )}
    </StyledModal>
  );
};

export default ModalSettingsVideo;
